<template>
  <div class="sourcing-request-list-app h-100 container-fluid">
    <div class="row h-100">
      <div class="col h-100">
        <div class="h-100 d-flex flex-column">
          <div class="mb-3 pt-4 d-flex justify-content-between align-items-end">
            <div>
              <h1>{{ pageTitle }}</h1>
              <p
                v-if="pageDescription"
                class="lead mb-0"
                >{{ pageDescription }}</p
              >
            </div>
            <div class="">
              <b-button
                v-if="enableStarter && startButtonConfig"
                :variant="startButtonConfig.variant || 'success'"
                :size="startButtonConfig.size || 'md'"
                @click="openStarter"
              >
                <b-icon
                  icon="plus-circle"
                  class="mr-1"
                ></b-icon>
                {{ startButtonConfig.text || 'New Sourcing Request' }}
              </b-button>
            </div>
          </div>

          <div class="w-100 flex-fill pb-4 h-100">
            <object-grid
              ref="sourcingRequestObjectGrid"
              model-class="SourcingRequest"
              :flow-subtype="flowSubtype"
              class="h-100"
              grid-max-height="100%"
              :block-size="100"
              col-state-local-storage-key="sourcing-request-list"
            ></object-grid>
          </div>
        </div>
      </div>
    </div>

    <flow-object-starter
      v-if="enableStarter"
      ref="sourcingRequestFlowStarter"
      flow-object-class="SourcingRequest"
      :flow-subtype="flowSubtype"
    ></flow-object-starter>
  </div>
</template>

<script>
  export default {
    name: 'AdvancedSourcingRequestList',
    props: {
      flowSubtype: {
        type: String,
        required: false,
        default: null,
      },
      listViewConfig: {
        type: Object,
        required: false,
      },
    },
    data() {
      return {};
    },
    computed: {
      pageTitle() {
        return this.listViewConfig?.page_title || 'Sourcing Requests';
      },
      pageDescription() {
        return this.listViewConfig?.page_description || '';
      },
      enableStarter() {
        return this.listViewConfig?.show_starter !== false;
      },
      startButtonConfig() {
        return this.listViewConfig?.start_button_config || null;
      },
    },
    methods: {
      openStarter() {
        const starter = this.$refs.sourcingRequestFlowStarter;
        if (starter) {
          starter.show();
        }
      },
      hideStarter() {
        const starter = this.$refs.sourcingRequestFlowStarter;
        if (starter) {
            starter.hide();
        }
      },
    },
  };
</script>
